import React from 'react';
import FormControl from '../../components/FormControl';
import { loadInventoryOptions, loadItemInfo } from './Helper';
import { ErrorToastComponent as ErrorToast } from '../../components/Toasts';
import { BasicCard } from '../../components/Card';
import { getQueryValue, postData } from '../../helper';
import { SuccessToastComponent as SuccessToast } from '../../components/Toasts';

class UpdateStockPage extends React.Component {
    constructor(props) {
        super();
        this.inventorySelectFormsubmitHandler = this.inventorySelectFormsubmitHandler.bind(this);
        this.inventoryInformation = this.inventoryInformation.bind(this);
        this.pageContent = this.pageContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.inventoryID = getQueryValue('inventory_id') ?? null;
        const self = this;
        this.state = {
            err_message: null,
            page_label: 'Update Stock',
            inventory_id: self.inventoryID,
            quantity: 0,
            inventorySelectForm: {
                onSubmit: self.inventorySelectFormsubmitHandler
            },
            fields: { 
                inventory_id: {
                    type: 'select-search',
                    placeholder: 'Item',
                    required: true,
                    options: {},
                    onChange: self.inventoryOnChangeHandler
                },
                create_button: {
                    type: 'button',
                    label: 'Next',
                    btn_type: 'submit'
                }
            }
        };
    }

    async componentDidMount() {
        try {

            const self = this;
            const currentFields = self.state.fields;
            currentFields.inventory_id.options = await loadInventoryOptions();
            currentFields.inventory_id.value = self.state.inventory_id;

            let itemInfo = {};
            if(self.inventoryID) 
                itemInfo = await loadItemInfo(self.inventoryID);

            self.setState({
                fields: currentFields,
                quantity: itemInfo.quantity,
                page_label: itemInfo.inventory_name ? `${self.state.page_label} (${itemInfo.inventory_name})` : self.state.page_label
            });

        } catch(err) {
            throw new Error(err.message);
        }
    }

    inventoryOnChangeHandler = (e) => {
        try {
            const fields = this.state.fields;
            fields.inventory_id.value = e.value;
            this.setState({fields: fields});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async inventorySelectFormsubmitHandler(payload) {
        try {

            const inventoryID = payload.inventory_id ?? null;
            window.location.href = `/inventory?screen=updatestock&inventory_id=${inventoryID}`;
            return;

        } catch(err) {
            return new Error(err.message);
        }
    }

    inventoryInformation() {
        try {
            if(!this.state.inventory_id)
                return <FormControl fields={this.state.fields} config={this.state.inventorySelectForm}/>
            else
                return (
                    <>
                        <p className='text-lg mb-0'>Available Quantity: 
                            <button type="button" className="btn btn-danger btn-icon-split margin-left-10 margin-right-10" onClick={this.decreaseQuantity}>
                                <span className="icon text-white-50">
                                    <i className="fas fa-minus"></i>
                                </span>
                            </button>
                            <span className='text-gray-900'>
                                <input
                                aria-describedby="textHelp" 
                                type="number" 
                                className="custom-number-field"
                                value={this.state.quantity} 
                                onChange={this.updateManually}
                                placeholder="quantity" />
                            </span>
                            <button type="button" className="btn btn-primary btn-icon-split margin-left-10" onClick={this.increaseQuantity}>
                                <span className="icon text-white-50">
                                    <i className="fas fa-plus"></i>
                                </span>
                            </button>
                            {this.updateButton()}
                        </p>
                    </>
                );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    decreaseQuantity = () => {
        try {
            const self = this;
            const currentQuantity = self.state.quantity > 0 ? self.state.quantity - 1 : self.state.quantity;
            self.setState({quantity: currentQuantity});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    increaseQuantity = () => {
        try {
            const self = this;
            const currentQuantity = self.state.quantity + 1;
            self.setState({quantity: currentQuantity});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    updateManually = (e) => {
        try {
            const self = this;
            const currentQuantity = e.target.value > 0 ? e.target.value - 1 : 0;
            self.setState({quantity: currentQuantity});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async handleSubmit() {
        try {

            const self = this;
            const payload = {
                inventory_id: self.state.inventory_id,
                quantity: self.state.quantity
            };

            const response = await postData('/inventory/quantity', payload, 'PUT');
            if(response && response.data && response.data.item) {
                self.setState({
                    show_success: true,
                    quantity: response.data.item.quantity
                });
            }

            setTimeout(() => {
                self.setState({show_success: false});
            },5000);

        } catch(err) {
            throw new Error(err.message);
        }
    }

    updateButton() {
        try {
            return (
                <button type="button" className="btn btn-success btn-icon-split margin-left-50" onClick={this.handleSubmit}>
                    <span className="icon text-white-50">
                        <i className="fas fa-sort-numeric-up"></i>
                    </span>
                    <span className="text">Update</span>
                </button>
            );
        } catch(err) {
            throw new Error(err.message);
        }
    }

    pageContent() {
        try {
            return (
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="card o-hidden border-0">
                                    <div className="card-body p-0">
                                        <div className="p-5">
                                            {this.inventoryInformation()}
                                            <ErrorToast message={this.state.err_message}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    render() {
        return (
            <>
                <div className='container'>
                    <BasicCard title={this.state.page_label} content={this.pageContent(this.props)}/>
                    {this.state.show_success ? <SuccessToast message='Quantity has been updated!'/> : ''}
                </div>
            </>
        )
    }
}


export default UpdateStockPage;